/*
Attribute details:
  stages: [required] String; a space-delimited list of stages tracked by the progress tracker
  stage-labels: [required] stringified Array; pretty stage names corresponding to `stages` list

Example usage:
  <amount-progress-tracker
    stages="personal rates_terms bank_accout additional_information"
    stage-labels="[
      'Personal Information',
      'Rates and Terms',
      'Bank Account Information',
      'Employment and Education'
    ]"
  >
  </amount-progress-tracker>

A note about use of the progress tracker in the Angular component menus:

The `stages` and `stage-labels` attributes correspond to each other through
an order-dependent 1:1 mapping. So whatever the third item in `stages`,
the third item in `stage-labels` will be the label used for that stage.

The values used in `stages` are usually real stage names coming from the
stage engine on the back end and are used for determining which steps
are  current/complete/pending for styling purposes. But for the component
menu, since there's no stage engine, the `currentStage` value is stubbed
out in the Angular `DemoCtrl` as `component`, so to simulate a specific
in-progress state, the stage `component` just needs to be substituted in
for whichever stage should appear to be the current stage.

The only other stage name that's actually significant is `rates_terms`
as that's used in determining whether to display product info (since it
doesn't exist until after `rates_terms` is complete). So for the  component
menu, the order/alignment of the `stages` and `stage-labels` values is
insignificant as long as `components` is used to indicate what stage-label should
be displayed as "current" for demo purposes, and as long as the relative
ordering of `components` and `rates_terms` corresponds to the desired state
of the product info portion of the progress tracker.
*/

const amountProgressTracker = () => {
  return {
    restrict: "E",
    template: require("./template.html"),
    scope: {
      stages: "@",
      stageLabels: "@",
    },
    link: (scope, element) => {
      // Parse attribute values
      scope.stagesArr = scope.stages.split(" ");
      scope.stageLabelsArr = scope.$parent.$eval(scope.stageLabels);

      // Parent methods
      scope.stageFromState = () => {
        return scope.$parent.stageFromState();
      };
      scope.displaySubHeader = () => {
        return scope.$parent.displaySubHeader();
      };
      scope.$parent.$on("product:data", (_ev, data) => {
        scope.product = data;
      });

      // Display helper methods
      scope.isCompletedStage = (idx) => {
        const stage = scope.stageFromState();
        return scope.stagesArr.indexOf(stage) > idx;
      }
      scope.isCurrentStage = (stage) => {
        return scope.stageFromState() === stage;
      };

      // Product information helpers
      scope.hasProductInformation = () => {
        return !!(
          scope.product &&
          scope.product.amount &&
          scope.product.fdic_apr_percentage &&
          scope.product.monthly_payment_display &&
          scope.product.term
        );
      }
      scope.isProductInformationFinalized = () => {
        const currentStage = scope.stageFromState();
        if (currentStage === 'contract') return true;
        return scope.stagesArr.indexOf(currentStage) > scope.stagesArr.indexOf('rates_terms');
      }
      scope.showProductInformation = () => {
        return scope.hasProductInformation() && scope.isProductInformationFinalized();
      }
    },
  };
}

angular
  .module("avant.customer_applications.directives")
  .directive("amountProgressTracker", amountProgressTracker);
